import { Directive } from "vue";

function hasExcludedClass(element: Element | null, exclude: string[]): boolean {
    let currentEl = element;
    while (currentEl) {
        const classString = currentEl.getAttribute("class") || "";

        if (classString) {
            for (const excludedClass of exclude) {
                if (classString.includes(excludedClass)) {
                    return true;
                }
            }
        }
        currentEl = currentEl.parentElement;
    }
    return false;
}

export default {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = (
            event: MouseEvent | TouchEvent | KeyboardEvent
        ) => {
            event.stopPropagation();
            const { handler, exclude } = binding.value;

            const clickedOnExcludedEl = hasExcludedClass(
                event.target as Element,
                exclude || []
            );

            if (
                !(
                    el == event.target ||
                    el.contains(event.target) ||
                    clickedOnExcludedEl
                )
            ) {
                handler();
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
        document.addEventListener("touchstart", el.clickOutsideEvent);

        document.onkeydown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                binding.value();
            }
        };
    },
    unmounted: el => {
        document.removeEventListener("click", el.clickOutsideEvent);
        document.removeEventListener("touchstart", el.clickOutsideEvent);
        document.onkeydown = null;
    }
} as Directive;
